var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{staticStyle:{"padding":"30px 15px 15px","position":"relative","max-width":"calc(100% - 15px)","margin-top":"15px"}},[_c('div',{staticClass:"s-card-box-title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('div',{staticStyle:{"min-height":"100px !important"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }